module.exports = __webpack_public_path__ + "static/media/firebird.39c00966.png";